export function scrollToRef(ref) {
  if (!ref?.current) return;
  ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

